import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { config } from 'src/app/valueObject/config';
import { environment } from 'src/environments/environment';

export interface HttpResponseData {
  httpResponse: HttpResponse<any>,
  catchedTimeInMilliSec: number
}

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  config: any = config;
  constructor() { }

  private cache = new Map<string, HttpResponseData>();
  private endPointsToCache = new Map<string, number>([
    [environment.URL + this.config.URL.getAllMembers, 600000],

  ]);



  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let options = {};

    if (request.url.includes('security/validateUser')) {
      options = {
        reportProgress: true,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
      };
    }
    // if (request.url.includes('compliance/uploadFile') || request.url.includes('/compliance/cyber/uploadCyberSecurity') || request.url.includes('/compliance/api/incident-report/v1.0/incidents') || request.url.includes('/enit/trade/uploadFile') ||
    //   request.url.includes('/compliance/uploadNtwrthFile') || request.url.includes('/compliance/uploadNetworthReport') || request.url.includes('/compliance/uploadEligibleFile')
    //   || request.url.includes('/compliance/addressChangeRequest/uploadChngInAddrFile') || request.url.includes('/compliance/addressChangeRequest/uploadIfcaFile')
    //   || request.url.includes('compliance/uploadFiles') || request.url.includes('/compliance/GlobalAccess/uploadFile') || request.url.includes('/compliance/addFiles')
    //   || request.url.includes('/compliance/AnnualReturn/uploadEligibleFile') ||
    //   request.url.includes('/compliance/AnnualReturn/uploadAttacheScanCpy')
    //   || request.url.includes('/compliance/ChangeInCM/uploadChngInClrngMemFile')
    //   || request.url.includes('/enit/trade/upldGovIdProofFile') || request.url.includes('/enitAudit/uploadSystemAuditSignPdf')
    //   || request.url.includes('/compliance/globalAccess/uploadGlobalAccessFile') || request.url.includes('/enit/p2pDeclarationFile')
    //   || request.url.includes('/enitAudit/SystemAuditEligiblityUploadFile') || request.url.includes('/enitAudit/CyberAuditEligiblityUploadFile') 
    //   || request.url.includes('/compliance/authPerson/uploadAuthPersonFile') || request.url.includes('/compliance/Surrender/uploadSurrenderDocuments')
    //   || request.url.includes('/enit/nnfRequest/uploadNnfDocuments')
    //   || request.url.includes('/enit/proEnablement/uploadProEnableUserDetails')  
    //   || request.url.includes('/enit/ipatmn/uploadNetworkFile') 
    //   ||request.url.includes('/enit/ipatmn/uploadIssueFile')  
    //   || request.url.includes('/compliance/memberDataFile/uploadFile')) {

    if (this.config.fileUploadURL.some(url => request.url.includes(url))) {
      options = {
        reportProgress: true,
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      };
    }
    else {
      options = {
        reportProgress: true,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      };
    }



    let updatedRequest = request.clone(options);

    let httpResponseDataToCache = {
      catchedTimeInMilliSec: 0,
      httpResponse: new HttpResponse()
    }

    if (this.endPointsToCache.has(request.url)) {
      const catchedTimeInMilliSecValue = this.endPointsToCache.get(request.url);
      if (this.cache.has(request.url)) {
        const httpResponseDataToCache = this.cache.get(request.url);
        if (catchedTimeInMilliSecValue > 0 && (Date.now() - httpResponseDataToCache.catchedTimeInMilliSec) > catchedTimeInMilliSecValue) {
          this.cache.delete(request.url);
        }
        else {
          if (httpResponseDataToCache.httpResponse) {
            return of(httpResponseDataToCache.httpResponse);
          }
        }
      }

      return next.handle(updatedRequest).pipe(
        tap((response) => {
          if (response instanceof HttpResponse) {
            httpResponseDataToCache.httpResponse = response;
            httpResponseDataToCache.catchedTimeInMilliSec = Date.now();
            this.cache.set(request.url, httpResponseDataToCache);
          }
        })
      );
    }

    return next.handle(updatedRequest);
  }
}
